export const STATUS = [
    { id: 'ALL', value: 'All' },
    { id: 'TODO', value: 'To Do' },
    { id: 'DONE', value: 'Done' },
    { id: 'SKIPPED', value: 'Skipped' },
];

const PREFIX = 'RESEARCH/';
const PREFIX_LOCAL = `LOCAL/${PREFIX}`;

export const GET_ALL_PROJECTS_REQUESTED = `${PREFIX}GET_ALL_PROJECTS_REQUESTED`;
export const GET_ALL_PROJECTS_SUCCEEDED = `${PREFIX}GET_ALL_PROJECTS_SUCCEEDED`;
export const GET_ALL_PROJECTS_FAILED = `${PREFIX}GET_ALL_PROJECTS_FAILED`;

export const GET_ALL_PLACES_REQUESTED = `${PREFIX}GET_ALL_PLACES_REQUESTED`;
export const GET_ALL_PLACES_SUCCEEDED = `${PREFIX}GET_ALL_PLACES_SUCCEEDED`;
export const GET_ALL_PLACES_FAILED = `${PREFIX}GET_ALL_PLACES_FAILED`;

export const GET_ALL_ZONES_REQUESTED = `${PREFIX}GET_ALL_ZONES_REQUESTED`;
export const GET_ALL_ZONES_SUCCEEDED = `${PREFIX}GET_ALL_ZONES_SUCCEEDED`;
export const GET_ALL_ZONES_FAILED = `${PREFIX}GET_ALL_ZONES_FAILED`;

export const RESEARCHERS_REQUESTED = `${PREFIX}RESEARCHERS_REQUESTED`;
export const RESEARCHERS_SUCCEEDED = `${PREFIX}RESEARCHERS_SUCCEEDED`;
export const RESEARCHERS_FAILED = `${PREFIX}RESEARCHERS_FAILED`;

export const GET_PLACES_REQUESTED = `${PREFIX}GET_PLACES_REQUESTED`;
export const GET_PLACES_SUCCEEDED = `${PREFIX}GET_PLACES_SUCCEEDED`;
export const GET_PLACES_FAILED = `${PREFIX}GET_PLACES_FAILED`;

export const CREATE_PROJECT_REQUESTED = `${PREFIX}CREATE_PROJECT_REQUESTED`;
export const CREATE_PROJECT_SUCCEEDED = `${PREFIX}CREATE_PROJECT_SUCCEEDED`;
export const CREATE_PROJECT_FAILED = `${PREFIX}CREATE_PROJECT_FAILED`;

export const EDIT_PLACE_REQUESTED = `${PREFIX}EDIT_PLACE_REQUESTED`;
export const EDIT_PLACE_SUCCEEDED = `${PREFIX}EDIT_PLACE_SUCCEEDED`;
export const EDIT_PLACE_FAILED = `${PREFIX}EDIT_PLACE_FAILED`;

export const DELETE_PLACE_REQUESTED = `${PREFIX}DELETE_PLACE_REQUESTED`;
export const DELETE_PLACE_SUCCEEDED = `${PREFIX}DELETE_PLACE_SUCCEEDED`;
export const DELETE_PLACE_FAILED = `${PREFIX}DELETE_PLACE_FAILED`;

export const UNASSIGN_RESEARCHER_REQUESTED = `${PREFIX}UNASSIGN_RESEARCHER_REQUESTED`;
export const UNASSIGN_RESEARCHER_SUCCEEDED = `${PREFIX}UNASSIGN_RESEARCHER_SUCCEEDED`;
export const UNASSIGN_RESEARCHER_FAILED = `${PREFIX}UNASSIGN_RESEARCHER_FAILED`;

export const ASSIGN_PLACES_REQUESTED = `${PREFIX}ASSIGN_PLACES_REQUESTED`;
export const ASSIGN_PLACES_SUCCEEDED = `${PREFIX}ASSIGN_PLACES_SUCCEEDED`;
export const ASSIGN_PLACES_FAILED = `${PREFIX}ASSIGN_PLACES_FAILED`;

export const ASSIGNEE_REQUESTED = `${PREFIX}ASSIGNEE_REQUESTED`;
export const ASSIGNEE_SUCCEEDED = `${PREFIX}ASSIGNEE_SUCCEEDED`;
export const ASSIGNEE_FAILED = `${PREFIX}ASSIGNEE_FAILED`;

export const RESET_PLACE_DETAIL = `${PREFIX}RESET_PLACE_DETAIL`;

export const SET_PROJECT = `${PREFIX_LOCAL}SET_PROJECT`;
export const SET_ZONE = `${PREFIX_LOCAL}SET_ZONE`;
export const SET_STATUS = `${PREFIX_LOCAL}SET_STATUS`;
export const SET_PLACES = `${PREFIX_LOCAL}SET_PLACES`;
export const SET_ACTIVE_PLACE_ID = `${PREFIX_LOCAL}SET_ACTIVE_PLACE_ID`;
export const SET_FILTER_BY = `${PREFIX_LOCAL}SET_FILTER_BY`;
export const SET_SORT_BY = `${PREFIX_LOCAL}SET_SORT_BY`;

export const SET_SELECTED_PLACES_ACTION = `${PREFIX}SET_SELECTED_PLACES_ACTION`;
export const SET_SELECTED_RESEARCHERS_ACTION = `${PREFIX}SET_SELECTED_RESEARCHERS_ACTION`;
